module.exports = __webpack_public_path__ + "static/media/mlmLogo.f66f7da0.png";